/**
 * Gli sconti di una riga d'ordine o di documento NTS, come "-5%" o
 * "-10% + 5%": senza, il totale della riga non torna con prezzo × quantità
 * (collaudo del 03/11/2026 sulle osservazioni del 30/10, D.D.T. 2/2026 di
 * 9012501: 3 × 15,65 € con il 5% = 44,60 €). `null` quando la riga non ha sconti.
 */
export function scontoRiga(scont1?: number | null, scont2?: number | null): string | null {
  const sconti = [scont1, scont2].filter((s): s is number => typeof s === 'number' && s > 0);
  if (!sconti.length) return null;
  return '-' + sconti.map(s => `${s.toLocaleString('it-IT')}%`).join(' + ');
}

/** Vero se almeno una riga ha uno sconto: solo allora le tabelle mostrano la colonna. */
export function righeConSconto(righe: { scont1?: number | null; scont2?: number | null }[]): boolean {
  return righe.some(r => scontoRiga(r.scont1, r.scont2) !== null);
}
